/**
 * Script simplifié pour rediriger vers l'ancre skeepers_product_widget
 */

(function() {
  'use strict';

    function handleStarsClick(e) {
    e.preventDefault();
    e.stopPropagation();

    // Faire un scroll smooth vers l'ancre
    const target = document.getElementById('skeepers_product_widget');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      // Ajouter l'ancre à l'URL après le scroll (optionnel)
      setTimeout(() => {
        window.history.replaceState(null, null, '#skeepers_product_widget');
      }, 500);
    }
  }

  function attachClickHandlers() {
    document.querySelectorAll('.skeepers_product__stars').forEach(function(element) {
      if (!element.dataset.customHandler) {
        element.dataset.customHandler = 'true';
        element.addEventListener('click', handleStarsClick, true);
      }
    });
  }

  // Observer pour les éléments ajoutés dynamiquement
  const observer = new MutationObserver(attachClickHandlers);
  observer.observe(document.body, { childList: true, subtree: true });

  // Attacher aux éléments existants
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachClickHandlers);
  } else {
    attachClickHandlers();
  }

})();
